var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus4Unactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0021 0C17.0506 0 0 17.047 0 37.9997C0 58.9479 17.0506 75.9997 38.0021 75.9997C58.9527 75.9997 75.9998 58.9479 75.9998 37.9997C75.9996 17.047 58.9527 0 38.0021 0ZM38.0021 73.1655C18.6102 73.1655 2.83301 57.3895 2.83301 37.9997C2.83301 18.6078 18.6102 2.83062 38.0021 2.83062C57.3918 2.83062 73.1702 18.6078 73.1702 37.9997C73.17 57.3895 57.3916 73.1655 38.0021 73.1655Z",
    fill: "#BEBEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0003 6C20.3578 6 6.00085 20.3542 6.00085 37.9989C6.00085 55.6434 20.3569 70 38.0003 70C55.6467 70 69.9997 55.6445 69.9997 37.9989C69.9997 20.3542 55.6476 6 38.0003 6ZM51.8496 31.4426L35.0904 48.2018C34.5872 48.7045 33.924 48.9582 33.267 48.9582C32.605 48.9582 31.948 48.7047 31.4431 48.2018L24.1544 40.9131C23.1467 39.9044 23.1467 38.273 24.1544 37.2655C25.1619 36.2579 26.7934 36.2579 27.8011 37.2655L33.267 42.7333L48.2051 27.7944C49.2106 26.788 50.8418 26.788 51.8496 27.7944C52.8573 28.8036 52.8573 30.4351 51.8496 31.4426Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus4Unactive);
export default __webpack_public_path__ + "static/media/status4-unactive.a80dcdd07921b7ed74c35afd894dfd21.svg";
export { ForwardRef as ReactComponent };